import React, { useRef } from "react";
import styled, { css } from "styled-components";
import { Provider } from "./context";

import { UnderConstruction } from "./components/UnderConstruction";
import { Home } from "./components/Home";

function App() {
  const body = useRef();

  return (
    <div className="App b00" ref={body}>
      <UnderConstruction mobileh mobile />

      <CSSutility><img height='8' src='https://api.netlify.com/api/v1/badges/dfd25fe5-c1f8-4b4a-b9e0-c0cb966ed8c4/deploy-status'/></CSSutility>
      <Provider>
        <Home />
      </Provider>
    </div>
  );
}

const CSSutility = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 1000000;
  display: flex;
  justify-content: flex-end;
`;

export default App;
